module.exports = __webpack_public_path__ + "img/img_not_found.c70529bf.png";